
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.5 10h-5a.5.5 0 01-.5-.5v-.29a.49.49 0 01.15-.36l1.78-1.78A6.93 6.93 0 0012 5a7 7 0 107 7.47.5.5 0 01.5-.47h1a.52.52 0 01.36.16.5.5 0 01.13.37 9 9 0 11-2.62-6.89l1.49-1.49a.49.49 0 01.35-.15h.29a.5.5 0 01.5.5v5a.5.5 0 01-.5.5z","fill":"#707273"}})])
          )
        }
      }
    